<template>
  <div>
    <!-- This can be your header or any other navigation components -->
    <!-- <nav>
      <router-link to="/vermittlungsportal"
        >Portal
        <font-awesome-icon icon="home" />
      </router-link>
    </nav> -->

    <!-- This is where the route components will be rendered -->
    <router-view />
    <LoadingOverlay :visible="loadingStore.isLoading" />
  </div>
</template>

<script setup lang="ts">
// import { FontAwesomeIcon } from "@fortawesome/vue-fontawesome";

/** COMPONENTS */
import { watch } from "vue";
import { useLanguageStore } from "@/stores/language";
import { useLoadingStore } from "@/stores/vermittlungsportal/loadingStore";
import LoadingOverlay from "@/components/LoadingOverlay.vue";
import { useAuswahlwerteStore } from "./stores/vermittlungsportal/auswahlwerte";
// import Api from "./Api";
import PublicApi from "./PublicApi";
import { useUserStore } from "@/stores/useUserStore";
import Api from "./Api";
import type { reservedDate } from "./models/ReservedDate";
import type { LangLocales } from "@/models/LangLocales";
import { useRoute } from "vue-router";


const languageStore = useLanguageStore();
const auswahlwerteStore = useAuswahlwerteStore();
const loadingStore = useLoadingStore();
const route = useRoute();

// Fetch translations and auswahlwerte immediately
async function setup() {
  await auswahlwerteStore.fetchAuswahlwerte();
  const langParam = typeof route.query.lang === "string" ? route.query.lang : null;
  const langId = languageStore.getLangIdByLocale(langParam as LangLocales);
  if (langId) {
    languageStore.setLanguage(langId);
    await languageStore.setLanguageTexts();
  }

  const userStore = useUserStore();

  PublicApi.get("angemeldeter-benutzer/", { withCredentials: true })
    .then(async (response) => {
      const user = {
        id: response.data.id as string,
        role: response.data.rolle as "jugendlicher" | "bauernfamilie",
        name: response.data.last_name ?? (response.data.name as string),
        firstName: response.data.first_name as string,
        email: response.data.email as string,
        username: response.data.username as string,
        profil: null, // Will be set later
        hasProfilePropertiesFilled: true, // Default value
        reservedDates: response.data.reserved_dates as reservedDate[],
      };

      const profile =
        user.role === "jugendlicher"
          ? await getProfile("profil/")
          : await getProfile("bf-profil/");

      user.profil = profile;
      user.hasProfilePropertiesFilled =
        userStore.importantProfilePropertiesFilled();

      userStore.setUser(user);
    })
    .catch(() => {
      userStore.clearUser();
      console.log("User not logged in or error fetching user data");
    });
}

const getProfile = async (endpoint: string) => {
  try {
    const response = await Api.get(endpoint, { withCredentials: true });
    return response.data;
  } catch (error) {
    console.error("Error fetching user profile:", error);
    return null;
  }
};

// Run setup immediately
setup();

// Sync i18n locale with language store and reload auswahlwerte when language changes
watch(
  () => languageStore.currentLangId,
  () => {
    auswahlwerteStore.fetchAuswahlwerte();
  }
);
</script>

<style scoped></style>
